import { render, staticRenderFns } from "./RsaPazienteRefertoListComponent.vue?vue&type=template&id=4c0b4433"
import script from "./RsaPazienteRefertoListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRefertoListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports